import React from 'react';
import { ResultCard, ResultList, ReactiveList } from '@appbaseio/reactivesearch';
import { css } from 'emotion';

const resultContainer = css`
	@media (max-width: 576px) {
		a {
			> div {
				width: 100px;
				height: 100px;
			}
			article {
				width: 300px;
			}
		}
	}
	@media (max-width: 400px) {
		a {
			> div {
				width: 100px;
				height: 100px;
			}
			article {
				width: 200px;
			}
		}
	}
	@media (max-width: 320px) {
		a {
			> div {
				width: 80px;
				height: 80px;
			}
			article {
				width: 200px;
			}
		}
	}
`;

const Results = () =>
	window.innerWidth <= 576 ? (
		<ReactiveList
			dataField="original_title.keyword"
			size={8}
			className={resultContainer}
			componentId="result"
			scrollOnChange={false}
			render={({ data }) => (
				<ReactiveList.ResultListWrapper>
					{data.map(item => (
						<ResultList key={item._id}>
							<ResultList.Image src={item.poster_path} />
							<ResultList.Content>
								<ResultList.Title>{item.original_title}</ResultList.Title>
								<ResultList.Description>{item.tagline}</ResultList.Description>
							</ResultList.Content>
						</ResultList>
					))}
				</ReactiveList.ResultListWrapper>
			)}
			react={{ and: ['search', 'genres', 'tagline'] }}
		/>
	) : (
		<ReactiveList
			dataField="original_title.keyword"
			size={8}
			className={resultContainer}
			componentId="result"
			scrollOnChange={false}
			render={({ data }) => (
				<ReactiveList.ResultCardsWrapper>
					{data.map(item => (
						<ResultCard key={item._id}>
							<ResultCard.Image src={item.poster_path} />
							<ResultCard.Title>{item.original_title}</ResultCard.Title>
							<ResultCard.Description>{item.tagline}</ResultCard.Description>
						</ResultCard>
					))}
				</ReactiveList.ResultCardsWrapper>
			)}
			react={{ and: ['search', 'genres', 'tagline'] }}
		/>
	);

export default Results;
